import {Iterable, List, Record, Map} from 'immutable';
import CoachingReviewAnswer from 'records/CoachingReviewAnswer';
import moment, {Moment} from 'moment';
import CoachingReviewFileUpload from 'records/CoachingReviewFileUpload';
import CoachingPlan, {PlanId} from 'records/CoachingPlan';

/**
 * Meant to represent the relevant details about a currently in progress review.
 *
 * @see InProgressReviewActions, InProgressReviewStore
 */
export default class InProgressReview extends Record({
  id: undefined,
  isPrepping: undefined,
  scheduleAt: undefined,
  planId: undefined,
  recipientId: undefined,
  reviewFileUploads: undefined,
  comment: undefined,
  reviewTypeAnswers: Map(),
  coachingReviewTypeId: undefined,
  adHoc: undefined,
  coachingPlan: undefined,
}) {
  id?: number;
  isPrepping: boolean;
  scheduleAt: Moment;
  planId?: PlanId;
  recipientId?: string;
  reviewFileUploads?: List<CoachingReviewFileUpload>;
  comment?: string;
  reviewTypeAnswers: Map<any, any>; // TODO
  coachingReviewTypeId?: number;
  adHoc: boolean;
  coachingPlan?: CoachingPlan; // Optional, never saved in store, but used by readyReviews to show adHoc in CoachingAgenda.

  constructor(object: Partial<InProgressReview> = {}) {
    super({
      ...object,
      scheduleAt: moment(object.scheduleAt),
      planId: object.planId,
      recipientId: object.recipientId,
      reviewFileUploads: object.reviewFileUploads
        ? Iterable.isIterable(object.reviewFileUploads)
          ? object.reviewFileUploads
          : List(object.reviewFileUploads.map(rf => new CoachingReviewFileUpload(rf)))
        : List(),
      comment: object.comment,
      // TODO Fix any
      reviewTypeAnswers: Map<any, any>(object.reviewTypeAnswers ?? {})
        .map(a => new CoachingReviewAnswer(a))
        .mapKeys(key => parseInt(key, 10)),
    });
  }

  //
  // Required for in-progress ad-hoc reviews to be sorted
  // in the coaching agenda.
  //
  get rep() {
    return this.coachingPlan && this.coachingPlan.recipient && this.coachingPlan.recipient.info;
  }
}
